export const columnListBudgetSetup = (groupType: string) => [
    { field: groupType, isLocalized: false },
    { field: 'Budget_Distribution', isLocalized: true, defaultValue: 'Budget Distribution', section: 'Budget' }
];

export const headerBudgetSetup = (total: string, locale: string) => [
    { cells: [{ text: 'GamificationAdmin', isLocalizedText: true, localizedSection: 'Page_Names', fontColor: [0, 0, 0], bold: true}] },
    { cells: [{ text: 'Budget_Setup', isLocalizedText: true, localizedSection: 'Budget', fontColor: [0, 0, 0], bold: true }] },
    { cells: [{ text: 'Company_Header', isLocalizedText: true, localizedSection: 'Budget' }, { customName: 'CompanyName' }] },
    { cells: [{ text: 'Month_Header', isLocalizedText: true, localizedSection: 'Budget' }, { text: new Date().toLocaleString(locale, { month: "long" }), isLocalizedText: true, localizedSection: "Common", }] },
    { cells: [{ text: 'Monthly_Total_Budget', isLocalizedText: true, localizedSection: 'Budget' },  { text: total }] },
    { cells: [{}] },// empty row
];